import {type MouseEvent, useCallback} from 'react';
import type {NativeSyntheticEvent, NativeTouchEvent} from 'react-native';

import type {ClickEventPayload, Props} from './types';

import {createEventNormalizer} from '../../utils/events';

export const useController = ({disabled, onClick}: Props) => {
  const clickHandler = useCallback(
    event => {
      if (disabled) {
        return;
      }

      const normalized = eventNormalizer(event);

      onClick?.(normalized);
    },
    [onClick, disabled],
  );

  return {clickHandler};
};

const eventNormalizer = createEventNormalizer<
  MouseEvent,
  NativeSyntheticEvent<NativeTouchEvent>,
  ClickEventPayload
>(
  event => ({
    pageX: event.pageX,
    pageY: event.pageY,
  }),
  event => ({
    pageX: event.nativeEvent.pageX,
    pageY: event.nativeEvent.pageY,
  }),
);
